import { type AngelouCSS, typographyStyles } from "@newsela/angelou";

export const notFoundCss: AngelouCSS = {
  alignItems: "center",
  background: "#F8F8F8",
  borderRadius: "8px",
  display: "flex",
  flexDirection: "column",
  height: "296px",
  padding: 20,
  justifyContent: "center",
};

export const headerCss: AngelouCSS = {
  margin: 5,
  ...typographyStyles.heading3Obj,
};
